import {takeLatest, put} from 'redux-saga/effects';
import {
  GET_DRIVERS,
  GET_DRIVERS_SUCCESS,
  GET_DRIVERS_FAILED,
  UPDATE_DRIVER,
  UPDATE_DRIVER_SUCCESS,
  UPDATE_DRIVER_FAILED,
  GET_VEHICLE_PREFERRED_SOURCES,
  GET_VEHICLE_PREFERRED_SOURCES_SUCCESS,
  GET_VEHICLE_PREFERRED_SOURCES_FAILED,
  GET_CENTERS,
  GET_CENTERS_SUCCESS,
  GET_CENTERS_FAILED,
  UPDATE_VEHICLE_PREFERRED_SOURCES,
  UPDATE_VEHICLE_PREFERRED_SOURCES_SUCCESS,
  UPDATE_VEHICLE_PREFERRED_SOURCES_FAILED,
  GET_DRIVER_SHIFTS_SUCCESS,
  GET_DRIVER_SHIFTS_FAILED,
  GET_DRIVER_SHIFTS,
  UPDATE_DRIVER_SHIFTS,
  UPDATE_DRIVER_SHIFTS_SUCCESS,
  UPDATE_DRIVER_SHIFTS_FAILED,
  UPDATE_DRIVER_STATUS_SUCCESS,
  UPDATE_DRIVER_STATUS_FAILED,
  UPDATE_DRIVER_STATUS,
  GET_DRIVER_SUCCESS,
  GET_DRIVER_FAILED,
  GET_DRIVER,
  CREATE_DRIVER_SUCCESS,
  CREATE_DRIVER_FAILED,
  CREATE_DRIVER,
  GET_DRIVERS_WALLET_SUCCESS,
  GET_DRIVERS_WALLET_FAILED,
  GET_DRIVERS_WALLET,
  ADD_DRIVERS_WALLET_TRANSACTION,
  ADD_DRIVERS_WALLET_TRANSACTION_SUCCESS,
  ADD_DRIVERS_WALLET_TRANSACTION_FAILED,
  GET_DRIVERS_WALLET_TRANSACTION,
  GET_DRIVERS_WALLET_TRANSACTION_FAILED,
  GET_DRIVERS_WALLET_TRANSACTION_SUCCESS,
  ADD_DRIVERS_WALLET_BULK_TRANSACTION_SUCCESS,
  ADD_DRIVERS_WALLET_BULK_TRANSACTION_FAILED,
  ADD_DRIVERS_WALLET_BULK_TRANSACTION,
} from './constants';

import {
  CreateDriverRequestBuilder,
  GetAllDriversRequestBuilder,
  GetDriversCountRequestBuilder,
  UpdateDriverRequestBuilder,
  UpdateDriverStatusRequestBuilder,
  GetDriversWalletsRequestBuilder,
  GetDriversSumWalletsRequestBuilder,
  AddDriverWalletTransactionRequestBuilder,
  GetDriverWalletTransactionRequestBuilder,
  GetDriverWalletTransactionCountRequestBuilder,
  AddDriverWalletBulkTransactionRequestBuilder,
} from 'client-sdk/src/drivers/drivers';
import {
  GetVehiclePreferredSourcesRequestBuilder,
  UpdateVehiclePreferredSourcesRequestBuilder,
} from 'client-sdk/src/vehicles/vehicles';
import {GetAllCentersRequestBuilder} from 'client-sdk/src/centers/centers';
import {
  CreateDriverShiftRequestBuilder,
  GetAllDriverShiftsRequestBuilder,
  UpdateDriverShiftRequestBuilder,
  CreateDriversShiftRequestBuilder,
} from 'client-sdk/src/driver-shifts/driver-shifts';

import Client from 'client-sdk/src/client';
import handleError from '../../utils/handleError';
import handleNotfication from '../../utils/handleNotification';

import {flattenObject} from '../../utils/helpers';

const token = localStorage.getItem('token') || '';
export function* getDrivers(actions: any): any {
  try {
    const makeDriversRequest = new GetAllDriversRequestBuilder()
      .params(flattenObject({...actions.payload}))
      .build();
    const makeCountRequest = new GetDriversCountRequestBuilder()
      .params(flattenObject({...actions.payload}))
      .build();
    const makeCountActiveRequest = new GetDriversCountRequestBuilder()
      .params(
        flattenObject({
          ...actions.payload,
          ...{employmentStatus: {equals: 'ACTIVE'}},
        })
      )
      .build();
    const makeCountDeactiveRequest = new GetDriversCountRequestBuilder()
      .params(
        flattenObject({
          ...actions.payload,
          ...{employmentStatus: {equals: 'OFF'}},
        })
      )
      .build();
    const client = new Client(token);
    const response = yield client.execute(makeDriversRequest);
    const count = yield client.execute(makeCountRequest);
    const activeCount = yield client.execute(makeCountActiveRequest);
    const deactiveCount = yield client.execute(makeCountDeactiveRequest);
    yield put({
      type: GET_DRIVERS_SUCCESS,
      data: response.data,
      count: count.data,
      activeCount: activeCount.data,
      deactiveCount: deactiveCount.data,
    });
  } catch (error) {
    yield put({
      type: GET_DRIVERS_FAILED,
      error: error.message,
    });
    handleError(error.response);
  }
}

export function* getDriversWallet(actions: any): any {
  try {
    const makeDriversRequest = new GetDriversWalletsRequestBuilder()
      .params(flattenObject({...actions.payload}))
      .build();

    const makeCountRequest = new GetDriversSumWalletsRequestBuilder()
      .params(flattenObject({...actions.payload}))
      .build();

    const client = new Client(token);
    const response = yield client.execute(makeDriversRequest);
    const count = yield client.execute(makeCountRequest);
    yield put({
      type: GET_DRIVERS_WALLET_SUCCESS,
      data: response.data,
      count: count.data,
    });
  } catch (error) {
    yield put({
      type: GET_DRIVERS_WALLET_FAILED,
      error: error.message,
    });
    handleError(error.response);
  }
}

export function* getDriver(actions: any): any {
  const {id, ...actionPayload} = actions.payload;
  try {
    const makeDriversRequest = new GetAllDriversRequestBuilder()
      .id(id)
      .params(flattenObject({...actionPayload}))
      .build();

    const client = new Client(token);
    const response = yield client.execute(makeDriversRequest);

    yield put({
      type: GET_DRIVER_SUCCESS,
      data: response.data,
    });
  } catch (error) {
    yield put({
      type: GET_DRIVER_FAILED,
      error: error.message,
    });
    handleError(error.response);
  }
}

export function* updateDriver(actions: any): any {
  const {body, callback} = actions.payload;
  try {
    const makeUpdateRequest = new UpdateDriverRequestBuilder()
      .data(body)
      .build();
    const client = new Client(token);
    yield client.execute(makeUpdateRequest);
    yield put({
      type: UPDATE_DRIVER_SUCCESS,
    });
    handleNotfication('اطلاعات راننده با موفقیت به روز رسانی شد', 'success');
    callback && callback();
  } catch (error) {
    yield put({
      type: UPDATE_DRIVER_FAILED,
      error: error.message,
    });
    handleError(error.response);
  }
}

export function* createDriver(actions: any): any {
  const {body, callback} = actions.payload;
  try {
    const makeCreateRequest = new CreateDriverRequestBuilder()
      .data(body)
      .build();
    const client = new Client(token);
    yield client.execute(makeCreateRequest);
    yield put({
      type: CREATE_DRIVER_SUCCESS,
    });
    handleNotfication('راننده با موفقیت ایجاد شد', 'success');
    callback && callback();
  } catch (error) {
    yield put({
      type: CREATE_DRIVER_FAILED,
      error: error.message,
    });
    handleError(error.response);
  }
}

export function* addDriverWalletTransaction(actions: any): any {
  const {id, body, callback} = actions.payload;
  try {
    const makeCreateRequest = new AddDriverWalletTransactionRequestBuilder()
      .id(id)
      .data(body)
      .build();
    const client = new Client(token);
    yield client.execute(makeCreateRequest);
    yield put({
      type: ADD_DRIVERS_WALLET_TRANSACTION_SUCCESS,
    });
    handleNotfication('تراکنش کیف پول راننده با موفقیت انجام شد', 'success');
    callback && callback();
  } catch (error) {
    yield put({
      type: ADD_DRIVERS_WALLET_TRANSACTION_FAILED,
      error: error.message,
    });
    handleError(error.response);
  }
}

export function* addDriverWalletBulkTransaction(actions: any): any {
  const {body, callback} = actions.payload;
  try {
    const makeCreateRequest = new AddDriverWalletBulkTransactionRequestBuilder()
      .data(body)
      .build();
    const client = new Client(token, 'application/octet-stream', {
      responseType: 'blob',
      Accept: 'application/octet-stream',
    });
    const response = yield client.execute(makeCreateRequest);
    yield put({
      type: ADD_DRIVERS_WALLET_BULK_TRANSACTION_SUCCESS,
      data: response.data,
      headers: response.headers,
    });
    handleNotfication(
      'تراکنش کیف های پول رانندگان با موفقیت انجام شد',
      'success'
    );
    callback && callback();
  } catch (error) {
    yield put({
      type: ADD_DRIVERS_WALLET_BULK_TRANSACTION_FAILED,
      error: error.message,
    });
    handleError(error.response);
  }
}

export function* getDriverWalletTransaction(actions: any): any {
  const {id, body, callback, ...actionsPayload} = actions.payload;
  try {
    const makeCreateRequest = new GetDriverWalletTransactionRequestBuilder()
      .id(id)
      .params(flattenObject({...actionsPayload}))
      .build();
    const makeCountRequest = new GetDriverWalletTransactionCountRequestBuilder()
      .id(id)
      .params(flattenObject({...actionsPayload}))
      .build();
    const client = new Client(token);
    const response = yield client.execute(makeCreateRequest);
    const count = yield client.execute(makeCountRequest);

    yield put({
      type: GET_DRIVERS_WALLET_TRANSACTION_SUCCESS,
      data: response.data,
      count: count.data,
    });
    callback && callback();
  } catch (error) {
    yield put({
      type: GET_DRIVERS_WALLET_TRANSACTION_FAILED,
      error: error.message,
    });
    handleError(error.response);
  }
}

export function* updateDriverStatus(actions: any): any {
  const {id, body} = actions.payload;
  try {
    const makeUpdateRequest = new UpdateDriverStatusRequestBuilder()
      .id(id)
      .data(body)
      .build();
    const client = new Client(token);
    yield client.execute(makeUpdateRequest);
    yield put({
      type: UPDATE_DRIVER_STATUS_SUCCESS,
    });
    yield put({
      type: GET_DRIVERS,
      payload: {page: 0, size: 10},
    });
    handleNotfication('وضعیت راننده با موفقیت به روز رسانی شد', 'success');
  } catch (error) {
    yield put({
      type: UPDATE_DRIVER_STATUS_FAILED,
      error: error.message,
    });
    handleError(error.response);
  }
}

export function* getVehiclePreferredSources(actions: any): any {
  try {
    const makeRequest = new GetVehiclePreferredSourcesRequestBuilder()
      .id(actions.payload)
      .build();
    const client = new Client(token);
    const response = yield client.execute(makeRequest);
    yield put({
      type: GET_VEHICLE_PREFERRED_SOURCES_SUCCESS,
      data: response.data,
    });
  } catch (error) {
    yield put({
      type: GET_VEHICLE_PREFERRED_SOURCES_FAILED,
      error: error.message,
    });
    handleError(error.response);
  }
}

export function* getCenters(actions: any): any {
  try {
    const makeRequest = new GetAllCentersRequestBuilder().build();
    const client = new Client(token);
    const response = yield client.execute(makeRequest);
    yield put({
      type: GET_CENTERS_SUCCESS,
      data: response.data,
    });
  } catch (error) {
    yield put({
      type: GET_CENTERS_FAILED,
      error: error.message,
    });
    handleError(error.response);
  }
}

export function* updateVehiclePreferredSources(actions: any): any {
  const {id, body} = actions.payload;
  try {
    const makeRequest = new UpdateVehiclePreferredSourcesRequestBuilder()
      .id(id)
      .data(Array.from(new Set(body)))
      .build();
    const client = new Client(token);
    yield client.execute(makeRequest);
    yield put({
      type: UPDATE_VEHICLE_PREFERRED_SOURCES_SUCCESS,
    });
  } catch (error) {
    yield put({
      type: UPDATE_VEHICLE_PREFERRED_SOURCES_FAILED,
      error: error.message,
    });
    handleError(error.response);
  }
}

export function* getDriversShifts(actions: any): any {
  const {id} = actions.payload;

  try {
    const makeRequest = new GetAllDriverShiftsRequestBuilder().id(id).build();

    const client = new Client(token);
    const response = yield client.execute(makeRequest);
    yield put({
      type: GET_DRIVER_SHIFTS_SUCCESS,
      data: response.data,
    });
  } catch (error) {
    yield put({
      type: GET_DRIVER_SHIFTS_FAILED,
      error: error.message,
    });
    handleError(error.response);
  }
}

export function* updateDriverShifts(actions: any): any {
  const {body, id, callback} = actions.payload;
  try {
    const makeRequest = new CreateDriversShiftRequestBuilder()
      .id(id)
      .data(body)
      .build();
    const client = new Client(token);
    yield client.execute(makeRequest);
    yield put({
      type: UPDATE_DRIVER_SHIFTS_SUCCESS,
    });
    handleNotfication('تغییر شیفت راننده با موفقیت انجام شد', 'success');
    callback && callback();
  } catch (error) {
    yield put({
      type: UPDATE_DRIVER_SHIFTS_FAILED,
      error: error.message,
    });
    handleError(error.response);
  }
}

export default function* driversSaga() {
  yield takeLatest(GET_DRIVERS, getDrivers);
  yield takeLatest(GET_DRIVERS_WALLET, getDriversWallet);
  yield takeLatest(GET_DRIVER, getDriver);
  yield takeLatest(UPDATE_DRIVER, updateDriver);
  yield takeLatest(CREATE_DRIVER, createDriver);
  yield takeLatest(ADD_DRIVERS_WALLET_TRANSACTION, addDriverWalletTransaction);
  yield takeLatest(
    ADD_DRIVERS_WALLET_BULK_TRANSACTION,
    addDriverWalletBulkTransaction
  );
  yield takeLatest(GET_DRIVERS_WALLET_TRANSACTION, getDriverWalletTransaction);
  yield takeLatest(UPDATE_DRIVER_STATUS, updateDriverStatus);
  yield takeLatest(GET_CENTERS, getCenters);
  yield takeLatest(GET_DRIVER_SHIFTS, getDriversShifts);
  yield takeLatest(GET_VEHICLE_PREFERRED_SOURCES, getVehiclePreferredSources);
  yield takeLatest(UPDATE_DRIVER_SHIFTS, updateDriverShifts);
  yield takeLatest(
    UPDATE_VEHICLE_PREFERRED_SOURCES,
    updateVehiclePreferredSources
  );
}
